<template>
  <div :id="uuid" class="p-8 bg-white rounded-xl">
    <div class="flex gap-3 flex-col md:flex-row">
      <template v-for="(column, index) in formData.columns" :key="index">
        <div
          class="marked flex-1"
          :style="{ color: column.textColor }"
          v-html="$marked(column.text)"
        />
      </template>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: 'TextColumnsView',
  props: {
    uuid: {
      type: String,
      required: true,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>
